import { render, staticRenderFns } from "./SignatureDetail.vue?vue&type=template&id=656b53dc&scoped=true"
import script from "./SignatureDetail.vue?vue&type=script&lang=js"
export * from "./SignatureDetail.vue?vue&type=script&lang=js"
import style0 from "./SignatureDetail.vue?vue&type=style&index=0&id=656b53dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656b53dc",
  null
  
)

export default component.exports